module.exports = __webpack_public_path__ + "img/modelshow03-3.8635c397.png";